import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { taskBoardColumnAPI } from '../../utilities/api';
import { Filing } from '../../utilities/interfaces/Filing';

// represents the shape of the slice in state
interface TaskBoardColumnState {
  value: any;
}

const initialState: TaskBoardColumnState = {
  value: [],
};

const taskBoardColumnSlice = createSlice({
  name: 'stateTaskBoardColumns',
  initialState,
  reducers: {
    // add new filing item
    addTaskBoardColumnItem(state, action: PayloadAction<Filing>) {
      // its okay to do this because immer makes it immutable
      state.value.push(action.payload);
    },
  },
  extraReducers(builder) {
    builder.addCase(getAllTaskBoardColumns.fulfilled, (state, action) => {
      state.value = action.payload;
    });
  },
});

// Async thunk to fetch data from api
// under extra reducers on fulfilled the redux store is updated
export const getAllTaskBoardColumns = createAsyncThunk(
  'stateTaskBoardColumns/getTaskBoardColumnItems',
  async () => {
    const response = await taskBoardColumnAPI.getTaskBoardColumns();
    return response;
  }
);

export const { addTaskBoardColumnItem } = taskBoardColumnSlice.actions;
export default taskBoardColumnSlice.reducer;
